import { useQuery, useQueryClient } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import { orderList } from 'services/apiOrders';

const useListOrders = (page=1, size=10,statusFilter,searchTerm,productFilter) => {

    const queryClient = useQueryClient();
    const{isPending, isSuccess, isError, error, data} = useQuery({
        queryKey:['orderList', page, size,statusFilter,searchTerm,productFilter],
        queryFn: ()=> orderList(page,size,statusFilter,searchTerm,productFilter),
        keepPreviousData:true,
        // staleTime: 2 * 60 * 60 * 1000
    })

    // prefetch data
    useEffect(()=>{
        console.log("initiated")
        if (data?.next){
            const nextPage = page + 1;
            queryClient.prefetchQuery({
                queryKey:['orderList',nextPage, size, statusFilter,searchTerm,productFilter],
                queryFn: ()=> orderList(nextPage, size,statusFilter,searchTerm,productFilter)
            })
        }
    },[data,page,size,statusFilter,searchTerm,productFilter,queryClient])

    return {isPending, isSuccess, isError, error, data}
}

export default useListOrders